module.exports = __webpack_public_path__ + "img/碳排放管理(1).14296f48.png";